import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import linkWithTagParam from '../../../../helpers/resourcesHelper';

const SearchCard = ({ searchItem, onTagClick, resourcesUrl }) => {
  const { heading, copy, url, isExternal, tags } = searchItem;

  const handleClick = e => {
    e.preventDefault();
    onTagClick(e.currentTarget.textContent);
  };

  return (
    <div className="search-result-card">
      <div className="search-result-card__heading">
        <a href={url} target={isExternal ? '_blank' : '_self'} rel="noreferrer">
          <h3>{parse(heading)}</h3>
        </a>
      </div>
      {copy && (
        <div className="search-result-card__description rtf">
          <p>{parse(copy)}</p>
        </div>
      )}
      {tags && (
        <div className="search-result-card__tags">
          <ul className="tags">
            {tags.map((tag, i) => (
              <li key={i}>
                <a href={linkWithTagParam(resourcesUrl, tag)} onClick={handleClick}>
                  {tag}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

SearchCard.propTypes = {
  heading: PropTypes.string,
  copy: PropTypes.string,
  url: PropTypes.string,
  searchItem: PropTypes.object,
  onTagClick: PropTypes.func,
  resourcesUrl: PropTypes.string,
};

export default SearchCard;
